export default [

     {
          path: '/third-party-vendor-repository-contact',
          name: 'ThirdPartyVendorRepositoryContact',
          component: () => import("@/views/Page/ThirdPartyVendorRepositoryContact/ThirdPartyVendorRepositoryContact.vue"),
           meta: {
               title: '#Default# | ThirdPartyVendorRepositoryContact',
          },
     }
];